import { useCallback, useEffect } from "react";

import { useParams } from "react-router-dom";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { userAccessStateByProjectIdSelector } from "Reducers/userAccess/userAccess.selectors";
import { useAppDispatch } from "Store/hooks";

import { listUserAccessesByProjectIdThunk } from "../thunks/listUserAccessesByProjectId.thunk";

export const useListUserAccessesByProjectId = (projectId?: string) => {
  const dispatch = useAppDispatch();
  const { projectId: URLProjectId } = useParams<{ projectId: string }>();
  projectId = projectId || URLProjectId;
  const state = useSelectorWithUrlParams(userAccessStateByProjectIdSelector);

  const load = useCallback(() => {
    if (projectId)
      return dispatch(listUserAccessesByProjectIdThunk({ projectId }));
  }, [projectId, dispatch]);

  useEffect(() => {
    if (state?.isLoading === undefined) load();
  }, [load, state?.isLoading]);

  return [state?.data, state?.isLoading, state?.error, load] as const;
};
